import React, { useEffect, useRef } from 'react'
import styles from './Banner.module.scss'

export type BannerVariant = 'success' | 'error' | 'info' | 'warning'

interface BannerProps {
    variant: BannerVariant
    message: React.ReactNode
    onDismiss?: () => void
    action?: React.ReactNode
    /** When true, scrolls the banner into view when it appears */
    autoScroll?: boolean
}

export const Banner: React.FC<BannerProps> = ({ variant, message, onDismiss, action, autoScroll }) => {
    const bannerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (autoScroll && bannerRef.current) {
            bannerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }, [autoScroll, message])

    return (
        <div ref={bannerRef} className={`${styles.banner} ${styles[variant]}`}>
            <div className={styles.content}>
                <span className={styles.message}>{message}</span>
                {action && <div className={styles.action}>{action}</div>}
            </div>
            {onDismiss && (
                <button onClick={onDismiss} className={styles.closeBtn} aria-label="Dismiss">
                    ×
                </button>
            )}
        </div>
    )
}

